<script>
import { VBreadcrumbsItem } from 'vuetify/lib'
import { routable } from '../../../mixins'
import { VIcon } from 'vuetify/lib/components'

export default {
  name: 'EBreadcrumbsItem',
  extends: VBreadcrumbsItem,
  mixins: [routable],
  props: {
    // In a breadcrumb, the currently
    // active item should be dimmed
    activeClass: {
      type: String,
      default: 'e-breadcrumbs__item--disabled',
    },
    icon: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    genIcon() {
      if (!this.icon) return null
      return this.$createElement(
        VIcon,
        {
          props: {
            size: this.small ? 20 : 24,
          },
        },
        this.icon
      )
    },
  },
  computed: {
    classes() {
      return {
        'e-breadcrumbs__item': true,
        'v-breadcrumbs__item': true,
        [this.activeClass]: this.disabled,
      }
    },
  },
  render(h) {
    const { tag, data } = this.generateRouteLink()
    return h('span', [
      h(tag, { ...data, attrs: { ...data.attrs, 'aria-current': this.isActive && this.isLink ? 'page' : undefined } }, [
        this.genIcon(),
        this.$slots.default,
      ]),
    ])
  },
}
</script>
